export const environment = {
    environmentName: 'production',
    cosentinoDotComUrl: 'https://cosentino.com',

    webComponent: false,
    publicUrl: 'https://we.cosentino.com',
    frontEndUrl: 'https://we.cosentino.com',
    previousPublicUrl: 'https://digital-apps.cosentino.com/we-app',
    previousFrontEndUrl: 'https://digital-apps.cosentino.com/we-app',
    alternativeRedirectUri: 'https://digital-apps.cosentino.com/we-app',

    production: true,
    API_URL: 'https://digital-apps.cosentino.com/back-we',
    MOCK_TOKEN:
        'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJzZGVsdmFsbGVAY29zZW50aW5vLmNvbSIsImRhdGEiOiJ7XCJ1c2VySWRcIjpudWxsLFwiaXNMZWFkc0IyQ0VuYWJsZWRcIjpmYWxzZSxcImVtYWlsXCI6XCJzZGVsdmFsbGVAY29zZW50aW5vLmNvbVwiLFwiZmlyc3ROYW1lXCI6bnVsbCxcImxhc3ROYW1lXCI6bnVsbCxcImFjY291bnROYW1lXCI6bnVsbCxcImFjY291bnRFbWFpbFwiOm51bGwsXCJhY2NvdW50UGhvbmVcIjpudWxsLFwiYWNjb3VudEJpbGxpbmdTdHJlZXRcIjpudWxsLFwiYWNjb3VudEJpbGxpbmdDaXR5XCI6bnVsbCxcImFjY291bnRCaWxsaW5nU3RhdGVcIjpudWxsLFwiYWNjb3VudEJpbGxpbmdQb3N0YWxDb2RlXCI6bnVsbCxcImNvbnRhY3RJZFwiOm51bGwsXCJhY2NvdW50SWRcIjpudWxsLFwiaXNNYWluQWNjb3VudFwiOmZhbHNlLFwicGFyZW50QWNjb3VudElkXCI6bnVsbCxcInBhcmVudEFjY291bnRFbWFpbFwiOm51bGwsXCJvd25lckFjY291bnRJZFwiOm51bGwsXCJvd25lckFjY291bnRFbWFpbFwiOm51bGwsXCJzYXBDdXN0b21lcklkXCI6bnVsbCxcInBhcmVudFNhcEN1c3RvbWVySWRcIjpudWxsLFwic3VwcGxpZXJTYXBJZFwiOm51bGwsXCJsb2NhdGlvblR5cGVcIjpudWxsLFwibGFuZ3VhZ2VDb2RlXCI6bnVsbCxcImNvdW50cnlDb2RlXCI6bnVsbCxcImFzc29jaWF0ZWRGYWJyaWNhdG9yQWNjb3VudElkXCI6bnVsbCxcImFzc29jaWF0ZWRGYWJyaWNhdG9yTmFtZVwiOm51bGwsXCJhc3NvY2lhdGVkRmFicmljYXRvclNhcElkXCI6bnVsbCxcInN1cnZleVNjb3JlXCI6bnVsbCxcInNhcENlbnRlcklkXCI6bnVsbCxcInNhcFNhbGVzT3JnSWRcIjpudWxsLFwibWluaW11bVN1cmZhY2VBcmVhXCI6bnVsbH0iLCJleHAiOjE3NDIyMTA1MzJ9.zBfivoQtgTMOE9VkEc9m0FAsGYS4SjahDMrZaWuNTrAPjv-IjDJybKb-2WmyKARANazKFR9R8JyIR1sNunOeIg',
    msal: {
        enabled: true,
        clientId: '9f3757bc-9035-4d63-b2ef-d4f46a024ff2',
        authority: 'https://cosentinogroupb2c.b2clogin.com/cosentinogroupb2c.onmicrosoft.com/b2c_1a_signup_signin',
        knownAuthorities: ['cosentinogroupb2c.b2clogin.com'],
        apiScopeUrl: 'cosentinogroupb2c.b2clogin.com',
        redirectUri: 'https://we.cosentino.com',
    },
    sentryDsn: 'https://f3bbb6e0f86043f76540dde0e43ee81b@o149177.ingest.us.sentry.io/4510815833948160',
    sentryTracePropagationApi: /^https:\/\/digital-apps\.cosentino\.com\/back-we/,
    sentryPerformanceTrackingRate: 1.0,

    samplesEndpoint: 'https://digital-apps.cosentino.com/samples',
    salesforceUrl: 'https://we.cosentino.com',
    // Cambios de Loyalty 2026 (cambiar a true cuando se quiera activar)
    loyalty2026: true,

    //REVIEW:: crear proyecto poeditor
    // poeditor: {
    //     apiKey: 'e6f597d3994744e292e5b1fe94cb1010',
    //     projectId: '765372',
    // }
    lotImageCdn: 'https://cdn-lots.cosentino.com/cosentino/slab/{lotId}.png',

    previousDomain: 'https://digital-apps.cosentino.com',
    notMigratedServices: [],
    migratedServices: {
        'https://digital-apps.cosentino.com/app-leads-b2c': 'https://we.cosentino.com/app-leads-b2c',
        'https://digital-apps.cosentino.com/c-nexus': 'https://we.cosentino.com/c-nexus',
        'https://digital-apps.cosentino.com/ctop-app': 'https://we.cosentino.com/ctop-app',
        'https://digital-apps.cosentino.com/financial-portal': 'https://we.cosentino.com/financial-portal',
    }
}
